module.exports = __webpack_public_path__ + "static/media/sp_wending.6678d8d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/sp_wending.svg
// module id = 226
// module chunks = 0